module.exports = __webpack_public_path__ + "static/media/flag-ht.034171ae.webp";